"use client";

import _slicedToArray from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useDialogDisclosure } from "../__chunks/35RDKJF6.js";
import "../__chunks/RM6VCCZ7.js";
import "../__chunks/JOBHIYEN.js";
import "../__chunks/ZHUQ44XA.js";
import { useHovercardProviderContext } from "../__chunks/DPAO6G5R.js";
import "../__chunks/COWZSPJ7.js";
import "../__chunks/CMXOY7UW.js";
import "../__chunks/JDEWEW7S.js";
import "../__chunks/Z4WWVOIF.js";
import "../__chunks/SWN3JYXT.js";
import { useVisuallyHidden } from "../__chunks/2ATXICAB.js";
import { createElement, createHook, forwardRef } from "../__chunks/7FZLUSKW.js";
import { useEvent, useMergeRefs } from "../__chunks/HNHAUIIY.js";
import "../__chunks/SK3NAZA3.js";
import { __objRest, __spreadProps, __spreadValues } from "../__chunks/3YLGPPWQ.js";

// src/hovercard/hovercard-disclosure.tsx
import { contains } from "@ariakit/core/utils/dom";
import { addGlobalEventListener } from "@ariakit/core/utils/events";
import { invariant } from "@ariakit/core/utils/misc";
import { sync } from "@ariakit/core/utils/store";
import { useEffect, useState } from "react";
import { jsx } from "react/jsx-runtime";
var TagName = "button";
var useHovercardDisclosure = createHook(function useHovercardDisclosure2(_a) {
  var _b = _a,
    store = _b.store,
    props = __objRest(_b, ["store"]);
  var context = useHovercardProviderContext();
  store = store || context;
  invariant(store, process.env.NODE_ENV !== "production" && "HovercardDisclosure must receive a `store` prop or be wrapped in a HovercardProvider component.");
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    visible = _useState2[0],
    setVisible = _useState2[1];
  useEffect(function () {
    if (!visible) return;
    var onBlur = function onBlur(event) {
      if (!store) return;
      var nextActiveElement = event.relatedTarget;
      if (nextActiveElement) {
        var _store$getState = store.getState(),
          anchor = _store$getState.anchorElement,
          popover = _store$getState.popoverElement,
          disclosure = _store$getState.disclosureElement;
        if (anchor && contains(anchor, nextActiveElement)) return;
        if (popover && contains(popover, nextActiveElement)) return;
        if (disclosure && contains(disclosure, nextActiveElement)) return;
        if (nextActiveElement.hasAttribute("data-focus-trap")) return;
      }
      setVisible(false);
    };
    return addGlobalEventListener("focusout", onBlur, true);
  }, [visible, store]);
  useEffect(function () {
    return sync(store, ["anchorElement"], function (state) {
      var anchor = state.anchorElement;
      if (!anchor) return;
      var observer = new MutationObserver(function () {
        if (!anchor.hasAttribute("data-focus-visible")) return;
        setVisible(true);
      });
      observer.observe(anchor, {
        attributeFilter: ["data-focus-visible"]
      });
      return function () {
        return observer.disconnect();
      };
    });
  }, [store]);
  var onClickProp = props.onClick;
  var onClick = useEvent(function (event) {
    onClickProp == null ? void 0 : onClickProp(event);
    if (event.defaultPrevented) return;
    store == null ? void 0 : store.setAutoFocusOnShow(true);
  });
  var onFocusProp = props.onFocus;
  var onFocus = useEvent(function (event) {
    onFocusProp == null ? void 0 : onFocusProp(event);
    if (event.defaultPrevented) return;
    setVisible(true);
  });
  var _useVisuallyHidden = useVisuallyHidden(),
    style = _useVisuallyHidden.style;
  if (!visible) {
    props = __spreadProps(__spreadValues({}, props), {
      style: __spreadValues(__spreadValues({}, style), props.style)
    });
  }
  var children = /* @__PURE__ */jsx("svg", {
    display: "block",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    viewBox: "0 0 16 16",
    height: "1em",
    width: "1em",
    children: /* @__PURE__ */jsx("polyline", {
      points: "4,6 8,10 12,6"
    })
  });
  props = __spreadProps(__spreadValues({
    children: children
  }, props), {
    ref: useMergeRefs(store.setDisclosureElement, props.ref),
    onClick: onClick,
    onFocus: onFocus
  });
  props = useDialogDisclosure(__spreadValues({
    store: store
  }, props));
  return props;
});
var HovercardDisclosure = forwardRef(function HovercardDisclosure2(props) {
  var htmlProps = useHovercardDisclosure(props);
  return createElement(TagName, htmlProps);
});
export { HovercardDisclosure, useHovercardDisclosure };